import Head from 'next/head';
import getConfig from 'next/config';
import { ThemeProvider } from 'styled-components';
import { Theme } from '@gymshark/theme';
import { Auth0Provider } from '@auth0/auth0-react';
import { datadogRum } from '@datadog/browser-rum'

import { Layout } from 'components/Layout/Layout';
import { LoginRedirect } from 'components/Hocs/LoginRedirect';
import { StoresProvider } from 'components/providers/Stores';
import { ConfigProvider } from 'components/providers/Config';

import 'reset-css';
import './../styles/global.css';

const App = ({ Component, pageProps, auth, api, dataDog }) => {
    datadogRum.init({
        applicationId: dataDog.APPLICATION_ID,
        clientToken: dataDog.CLIENT_TOKEN,
        site: dataDog.SITE,
        service: 'store-sync',
        env: dataDog.ENV,
        version: dataDog.VERSION,
        trackUserInteractions: true,
        useSecureSessionCookie: true,
    });

    return (
        <Auth0Provider {...auth}>
            <LoginRedirect>
                <ConfigProvider initialConfig={{ api }}>
                    <StoresProvider>
                        <ThemeProvider theme={{ ...Theme }}>
                            <Head>
                                <title>Gymshark Shopify Sync Admin - Store</title>
                            </Head>

                            <Layout>
                                <Component {...pageProps} />
                            </Layout>
                        </ThemeProvider>
                    </StoresProvider>
                </ConfigProvider>
            </LoginRedirect>
        </Auth0Provider>
    );
};

App.getInitialProps = async () => ({
    auth: {
        domain: process.env.AUTH_DOMAIN,
        clientId: process.env.AUTH_CLIENT_ID,
        authorizationParams: {
            redirect_uri: process.env.AUTH_REDIRECT_URI,
            scope: process.env.AUTH_SCOPE,
            audience: process.env.AUTH_AUDIENCE
        }
    },
    api: {
        API_HOST: process.env.API_HOST,
        ALGOLIA_KEY: process.env.ALGOLIA_KEY
    },
    dataDog: {
        APPLICATION_ID: process.env.DATADOG_APPLICATION_ID,
        CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN,
        SITE: process.env.DATADOG_SITE,
        ENV: process.env.DATADOG_ENV,
        VERSION: process.env.DATADOG_VERSION,
    }
});


export default App;

